import React from 'react'
import PropTypes from 'prop-types'
import useMessageFormat from '@/hooks/intl/useMessageFormat'
import { BackButton, CloseButton } from '../buttons'
import { goBack, goToMyAccount } from '../../utils/navigate'
import { css } from '@emotion/core'
import { modalTitleCss, modalContentCss, modalContentHeaderCss } from './styles'
import PayPalLogo from '../common/PayPalLogo'
import { isGBDebitCardEnrollmentFlow } from 'utils/flow'
import qs from 'query-string'
import { PRODUCT_NAMES } from 'universal/cfs-card'
import { FLOW_STEPS } from '@/constants/flow-steps'
const { CONSUMER_DEBIT_CARD } = PRODUCT_NAMES
const { FUNDING_INSTRUMENT_STEP } = FLOW_STEPS.ENROLL_CARD

function ModalNavBar({
  titleContent = {},
  stepper,
  hideCloseButton,
  showBackButton,
  onClose,
  onFirstStepBack,
  showTitle,
}) {
  const { previousStep, isFirstStep, getCurrentStepName  } = stepper
  const { formatMessage } = useMessageFormat()

  const headerRelativeCss = css`
    position: relative;
  `

  const logoOverlayCss = css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    pointer-events: none;
  `

  const isPPDCRequestCardFlow = () => {
    let intent = qs.parse(window.location.search).intent;
    let productName = qs.parse(window.location.search).productName;
    return getCurrentStepName() === 'setPin' && productName === CONSUMER_DEBIT_CARD && intent === 'requestPhysicalCard';
  }

  const handleCloseBtn = () => {
    if (onClose) {
      onClose()
      return
    }
    goToMyAccount()
  }

  const handleBackBtnClick = (e) => {
    e.preventDefault(0)

    if (isFirstStep()) {

      if(isPPDCRequestCardFlow()){
        handleCloseBtn()
        return;
      }
      

      if (onFirstStepBack) {
        onFirstStepBack()
        return
      }
      goBack()
      return
    }
    previousStep()
  }

  // Hide back button for specific funding instrument steps
  const currentStepName = getCurrentStepName()
  const shouldHideBackButtonForFundingSteps = isGBDebitCardEnrollmentFlow && currentStepName === FUNDING_INSTRUMENT_STEP
  const finalShowBackButton = showBackButton && !shouldHideBackButtonForFundingSteps

  const backButton = finalShowBackButton && (
    <BackButton onClick={handleBackBtnClick} backtext={formatMessage('app.button.back')} />
  )



  const { id: titleContentId, values: titleContentValues = {} } = titleContent || {}

  return (
    <header className="ppvx_modal-header ppvx_modal-header--no-logo">
      <div css={css([modalContentCss, modalContentHeaderCss, headerRelativeCss])}>
        {/* Centered overlay logo above actions/title */}
        {/* eslint-disable-next-line i18n-scan/no-country-dependency -- GB-specific PayPal logo overlay for compliance */}
        { isGBDebitCardEnrollmentFlow() && (
          <div css={logoOverlayCss}>
            <PayPalLogo height="30px" style={{ padding: 0 }} />
          </div>
        )}
        <div className="ppvx_modal-header__action">{finalShowBackButton && backButton}</div>
        {showTitle && titleContentId && (
          <div className="ppvx_modal-header__title" data-testid="modal-title" id="modal-header" css={modalTitleCss}>
            {formatMessage(titleContentId, titleContentValues)}
          </div>
        )}
        {hideCloseButton ? (
          <div className="ppvx_modal-header__action" />
        ) : (
          <CloseButton onClick={handleCloseBtn} ariaLabel={formatMessage('funding.button.close')} />
        )}
      </div>
    </header>
  )
}

ModalNavBar.propTypes = {
  titleContent: PropTypes.object,
  stepper: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onFirstStepBack: PropTypes.func,
  hideCloseButton: PropTypes.bool,
  showBackButton: PropTypes.bool,
  showTitle: PropTypes.bool,
}

export default ModalNavBar
